export default String.raw`
.lookbook {
    margin: 0 auto;
    padding:  0 9% 32px 9%;

    &__container {
        $column-gap: 24px;
        $row-gap: 48px;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, calc((100% - $column-gap) / 2));
        gap: $row-gap $column-gap;
        padding: 32px 0;

        h2 {
            text-align: center;
            color: $primaryColorFont;
        }

        &.with-points {
            row-gap: $column-gap;
        }
    }

    &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
        width: 100%;
        gap: 16px;
        aspect-ratio: 16 / 9;
        cursor: pointer;

        &.with-points {
            cursor: auto;
        }

        > .button__group {
            position: absolute;
            visibility: hidden;
            top: 8px;
            right: 8px;
            width: unset;

            .secondary-action-button {
                padding: 8px;
            }
        }

        > img {
            width: 100%;
            border-radius: 8px;
        }

        &-product {
            display: flex;
            justify-content: center;
            align-items: center;
            visibility: hidden;
            position: absolute;
            z-index: 1;
            width: 300px;
            min-height: 300px;
            padding: 16px;
            background-color: $bgColor;
            border-radius: 8px;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
            transition: 0.5s;

            .card-product {
                height: auto;

                &__buttons {
                    button {
                        transition: background-color 200ms, color 200ms, border-color 200ms;
                    }

                    svg {
                        transition: fill 200ms;
                    }
                }
            }
        }

        .point {
            position: absolute;
            cursor: pointer;
            width: 24px;
            height: 24px;

            &__svg {
                width: 24px;
                height: 24px;
                fill: $bgColor;
                opacity: 0.7;
            }

            &:hover,
            &:focus,
            &:focus-within {
                &[aria-expanded="true"] {
                    .point__svg {
                        opacity: 1;
                        fill: #cb6724;
                    }
                    .lookbook__item-product {
                        visibility: visible;
                    }
                }
            }
        }
    }
}
`